<template>
	<div class="">
	<b-modal id="modal-payment-failed"
			 hide-footer
			 hide-header
			 @hide="$router.push('/')"
	>
		<div class="wrap-img">
			<img src="../assets/images/ducks/send.png" alt="">
		</div>
		<div class="modal-content">
			<h2 class="title">Something went wrong</h2>
			<button @click.prevent="$bvModal.show('modal-feedback')" class="btn btn-contact-support">
				Contact Support
			</button>
		</div>
	</b-modal>
	<Feedback :id="'modal-feedback'"
			  :title="'Contact support'"
			  :phone="'1234567'"
			  :text_placeholder="'How can we help?'"
			  api_title="Payment failed"
	/>
	</div>
</template>

<script>
	import Feedback from "../components/Feedback";

	export default {
		name: "PaymentFailed",
		components:{
			Feedback,
		},
		mounted() {
			// if (!localStorage.accessToken) {
			// 	this.$router.push("/")
			// }
			this.$bvModal.show('modal-payment-failed')

		}
	};
</script>
<style scoped lang="scss">
	::v-deep .modal-body {
		padding: 0;
	}

	.modal-content {
		padding: 20px 25px 25px 25px;
		@include media-breakpoint-up(sm) {
			padding: 40px 50px 50px 50px;
		}

		.title {
			text-align: center;
		}
	}

	.wrap-img {
		padding-top: 26px;
		padding-bottom: 26px;
		background: #21405B;
		text-align: center;
		min-height: 169px;
	}

	.btn-contact-support{
		color: #FF7A00;
		text-decoration: none;
		font-weight: 600;
	}
</style>